'use client';

import classnames from 'classnames';
import { Container } from '@stadionhq-v3/base-ui';
import { Captain } from '@stadionhq-v3/scottishfa-web-tokens/dist/components/icons';
import { SfaPlayerStatusChip } from '../../atoms/sfa-player-status-chip';
import { SfaPlayerStatCard } from '../../atoms/sfa-player-stat-card';
import { SfaShirtCtaBar } from '../../atoms/sfa-shirt-cta-bar';
import { SfaPlayerNameBlock } from '../../molecules/sfa-player-name-block';
import { SfaPlayerProfileNav } from '../../molecules/sfa-player-profile-nav';
import { SfaPlayerProfileHeaderProps } from './sfaPlayerProfileHeader.types';
import styles from './sfaPlayerProfileHeader.module.scss';

const SfaPlayerProfileHeader = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-player-profile-header',
  variant = 'complex',
  firstName,
  lastName,
  position,
  countryFlag,
  profileImage,
  backgroundImage,
  isCaptain,
  captainIcon,
  stats,
  nav,
  shirtCta,
}: SfaPlayerProfileHeaderProps) => {
  const showPosition = !!position && position !== 'Unknown';
  const showStats = variant === 'complex' && stats && stats.length > 0;

  return (
    <header
      {...nativeProps}
      data-testid={testId}
      className={classnames(styles.sfaPlayerProfileHeader, classNames)}
    >
      {nav ? <SfaPlayerProfileNav {...nav} /> : null}

      <div className={styles.hero}>
        {backgroundImage ? (
          <div className={styles.heroBackground} aria-hidden="true">
            {backgroundImage}
          </div>
        ) : null}
        <div className={styles.heroGradient} aria-hidden="true" />

        <Container classNames={[classnames(styles.heroContainer)]}>
          {profileImage ? (
            <div className={styles.profileImage}>{profileImage}</div>
          ) : null}

          <div className={styles.info}>
            {isCaptain ? (
              <div className={styles.captain}>
                <SfaPlayerStatusChip
                  variant="captain"
                  label="Captain"
                  icon={captainIcon ?? <Captain />}
                />
              </div>
            ) : null}

            <SfaPlayerNameBlock
              firstName={firstName}
              lastName={lastName}
              alignment="start"
              headingLevel="h1"
            />

            {showPosition || countryFlag ? (
              <div className={styles.positionRow}>
                {countryFlag ? (
                  <span className={styles.flag} aria-hidden="true">
                    {countryFlag}
                  </span>
                ) : null}
                {showPosition ? <span>{position}</span> : null}
              </div>
            ) : null}

            {showStats ? (
              <dl className={styles.stats} aria-label="Player statistics">
                {stats!.map((stat) => (
                  <SfaPlayerStatCard
                    key={stat.label}
                    label={stat.label}
                    value={stat.value}
                  />
                ))}
              </dl>
            ) : null}
          </div>
        </Container>
      </div>

      {shirtCta ? <SfaShirtCtaBar {...shirtCta} /> : null}
    </header>
  );
};

export default SfaPlayerProfileHeader;
